const ADMIN_TOKEN_KEY = 'bokeh_admin_token';

export function getAdminToken() {
  try {
    return sessionStorage.getItem(ADMIN_TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

export function setAdminToken(token) {
  try {
    if (token) sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
    else sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch {
    // ignore storage failures
  }
}

export function clearAdminToken() {
  setAdminToken('');
}

export function getAdminAuthHeaders(extra = {}) {
  const headers = { ...extra };
  const token = getAdminToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

/** Fetch wrapper for admin APIs — sends Bearer token + cookies. */
export function adminFetch(url, options = {}) {
  const { headers: optionHeaders, ...rest } = options;
  const headers = new Headers(optionHeaders || {});
  const token = getAdminToken();
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(url, {
    ...rest,
    credentials: 'include',
    headers,
  });
}
